import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class LayerSelectionButton extends ToolbarButton {
    constructor() {
        super('layer-group', 'Select Layers', 'layerBtn');
    }
    _action() {
        const $layers = $('#layerbox');
        $layers.toggleClass('hidden');
    }
}
